const Filetypes = ["抓包", "日志", "autop", "文件"];
let filetypesList = [];
for (let i in Filetypes) filetypesList.push({ ID: i, Name: Filetypes[i] });

const Alarmlevels = ["未分类", "灾难", "严重", "一般", "警告", "信息"];
let alarmlevelsList = [];
for (let i in Alarmlevels)
  alarmlevelsList.push({ ID: i, Name: Alarmlevels[i] });

const Equipmenttypes = ["APP", "门口机", "室内机"];
let equipmenttypesList = [];
for (let i in Equipmenttypes)
  equipmenttypesList.push({ ID: i, Name: Equipmenttypes[i] });

const Alarmstatus = ["未处理", "处理中", "已解决"];
let alarmstatusList = [];
for (let i in Alarmstatus)
  alarmstatusList.push({ ID: i, Name: Alarmstatus[i] });

const Channelstatus = ["关闭", "开启"];
let channelstatusList = [];
for (let i in Alarmstatus)
  channelstatusList.push({ ID: i, Name: Channelstatus[i] });

const Flags = ["进行中", "已完成", "失败", "取消"];
let flagsList = [];
for (let i in Flags) flagsList.push({ ID: i, Name: Flags[i] });

const Channels = [
  "重启设备",
  "重启dclient",
  "恢复出厂设置",
  "关闭告警通道",
  "autop",
  "修改保活时间（单位：秒）"
];

const Cmds = ["console", "console", "console", "config", "config", "keepalive"];

const Params = [
  "reboot",
  "killself",
  "reset",
  "Config.DoorSetting.CLOUDSERVER.MaintenanceAlarm=0",
  "",
  ""
];
let channelsList = [];
for (let i in Channels)
  channelsList.push({
    ID: i,
    Cmd: Cmds[i],
    Param: Params[i]
  });

const Organizationals = ["公司", "部门"];
let organizationalsList = [];
for (let i in Organizationals)
  organizationalsList.push({ ID: i, Name: Organizationals[i] });

const Operats = ["创建", "删除", "编辑", "查看"];
let operatsList = [];
operatsList.push({ Action: "create", Name: Operats[0] });
operatsList.push({ Action: "delete", Name: Operats[1] });
operatsList.push({ Action: "update", Name: Operats[2] });
operatsList.push({ Action: "view", Name: Operats[3] });

const WriteStatus = ["未烧写", "已烧写"];
const SyncStatus = ["未同步", "已同步"];
const StorageTypes = ["阿里云OSS", "亚马逊云S3"];
const SwitchStatus = ["关闭", "开启"];
const TaskStatus = ["禁用", "启用"];
const DeviceStatus = ["离线", "在线"];
const DeviceTypes = [
  { name: "社区设备", value: 0 },
  { name: "单住户设备", value: 1 }
];
const NotifyToWeixinStatus = ["未通知", "已通知", "通知失败"];
const HasStatus = ["否", "是"];
const DeviceActionTypes = [
  { name: "通话", value: 1 },
  { name: "开门", value: 2 }
  // { name: '截图', value: 4 }
];
const DeviceConfigTypes = [
  { name: "Config", value: 0, type: "plaintext" },
  { name: "Privatekey", value: 1, type: "xml" },
  { name: "Rfid", value: 2, type: "xml" },
  { name: "Contact", value: 3, type: "xml" },
  { name: "Schedule", value: 5, type: "json" },
  { name: "UserMeta", value: 6, type: "json" },
  { name: "UserAll", value: 7, type: "json" }
];

const DeviceRomTaskStatus = ["进行中", "已完成", "失败", "就绪", "定时脚本处理中", "定时脚本处理成功", "定时脚本处理失败", "发布到对讲云失败", "后台处理中", "后台处理失败", "网络超时"];
const DeviceRomLangTypes = ["英文", "中文", "日文"]
const DeviceRomReleaseTypes = ["未知", "正式版", "Beta版", "LTS版", "过渡版"]

const SubscriberEmailTemplateTypes = [
  { name: "公司内部", value: 1 },
  { name: "外部客户", value: 2 }
]

export {
  Filetypes,
  filetypesList,
  Alarmlevels,
  alarmlevelsList,
  Equipmenttypes,
  equipmenttypesList,
  Alarmstatus,
  alarmstatusList,
  Flags,
  flagsList,
  Channels,
  channelsList,
  Channelstatus,
  channelstatusList,
  Organizationals,
  organizationalsList,
  Operats,
  operatsList,
  WriteStatus,
  SyncStatus,
  StorageTypes,
  SwitchStatus,
  TaskStatus,
  DeviceStatus,
  DeviceTypes,
  NotifyToWeixinStatus,
  HasStatus,
  DeviceActionTypes,
  DeviceConfigTypes,
  DeviceRomTaskStatus,
  DeviceRomLangTypes,
  DeviceRomReleaseTypes,
  SubscriberEmailTemplateTypes
};
